import styled, { css } from 'styled-components';
import { down } from 'styled-breakpoints';

export const Container = styled.article`
  height: 100%;
`;

export const PageHeader = styled.header`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 0.75rem;
    margin-top: 0.5rem;
    margin-bottom: 1.5rem;

    h1 {
      font-size: 1.375rem;
      font-weight: 800;
      color: ${theme.colors.foreground[100]};
      letter-spacing: -0.5px;
    }
  `}
`;

export const BackButton = styled.button`
  ${({ theme }) => css`
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 0.75rem;
    border: none;
    background: transparent;
    cursor: pointer;
    color: ${theme.colors.brand.primary.default};
    display: flex;
    align-items: center;
    justify-content: center;
    transition: ${theme.transition.default};

    :hover {
      background: ${theme.colors.brand.primary.opaque};
    }
  `}
`;

export const Wrapper = styled.section`
  ${() => css`
    display: flex;
    padding-right: 420px;

    ${down('xl')} {
      flex-direction: column;
      padding-right: 0;
    }
  `}
`;
